// ─── Gestão de Documentos — constants ────────────────────────────────────────

export const ITENS_POR_PAGINA = 10;
export const POR_PAGINA = 4;
export const HISTORICO_ITENS_POR_PAGINA = 10;
export const BUCKET = 'upload-ic-files';
export const ACCEPTED_EXTENSIONS = ['.zip', '.rar'];

export const MODELO_NOME: Record<string, string> = {
  NFE: 'NF-e',
  NFC: 'NFC-e',
  CTE: 'CT-e',
  NF3E: 'NF3-e',
  NFCom: 'NFCom',
  NFGas: 'NFGas',
  NFS: 'NFS-e',
};

export const MODELOS_COM_ITENS = new Set(['55', '65']);
export const MODELOS_COM_EVENTOS = new Set(['55', '65', '57']);
export const MODELO_KEY: Record<string, 'nfe' | 'nfc'> = { '55': 'nfe', '65': 'nfc' };

export const PERIODOS = [
  { label: 'Desde Ontem', value: 1 },
  { label: 'Últimos 7 dias', value: 7 },
  { label: 'Últimos 10 dias', value: 10 },
  { label: 'Últimos 15 dias', value: 15 },
  { label: 'Últimos 30 dias', value: 30 },
  { label: 'Últimos 60 dias', value: 60 },
  { label: 'Últimos 90 dias', value: 90 },
];

export const STATUS_MAP: Record<string, { label: string; className: string }> = {
  '0': { label: 'Aguardando', className: 'bg-yellow-100 text-yellow-800' },
  '1': { label: 'Aguardando', className: 'bg-yellow-100 text-yellow-800' },
  '2': { label: 'Processando', className: 'bg-blue-100 text-blue-800' },
  '3': { label: 'Concluído', className: 'bg-green-100 text-green-800' },
  '9': { label: 'Cancelado', className: 'bg-red-100 text-red-700' },
};

// ─── Shared ──────────────────────────────────────────────────────────────────

export const MODELOS_OPCOES = [
  { value: '13', label: 'NFS-e (Modelo 13)' },
  { value: '55', label: 'NF-e (Modelo 55)' },
  { value: '65', label: 'NFC-e (Modelo 65)' },
  { value: '57', label: 'CT-e (Modelo 57)' },
  { value: '59', label: 'SAT (Modelo 59)' },
  { value: '62', label: 'NFCom (Modelo 62)' },
  { value: '66', label: 'NF3-e (Modelo 66)' },
  { value: '75', label: 'NFAg (Modelo 75)' },
  { value: '76', label: 'NFGas (Modelo 76)' },
] as const;

export const TIPOS_EXPORTACAO = [
  { value: 'excel', label: 'Excel', extension: '.xlsx', icon: 'FileSpreadsheet' },
  { value: 'pdf', label: 'PDF', extension: '.pdf', icon: 'FileText' },
  { value: 'csv', label: 'CSV', extension: '.csv', icon: 'File' },
] as const;

export const ESTADO_MODELOS_INICIAL = {
  nfe: false,
  nfag: false,
  nfc: false,
  cte: false,
  sat: false,
  nfcom: false,
  nfgas: false,
  nf3e: false,
  nfse: false,
} as const;

export const PAGINACAO_MODELOS_INICIAL = {
  nfe: { pagina: 1, itensPorPagina: 10 },
  nfag: { pagina: 1, itensPorPagina: 10 },
  nfc: { pagina: 1, itensPorPagina: 10 },
  cte: { pagina: 1, itensPorPagina: 10 },
  sat: { pagina: 1, itensPorPagina: 10 },
  nfcom: { pagina: 1, itensPorPagina: 10 },
  nfgas: { pagina: 1, itensPorPagina: 10 },
  nfse: { pagina: 1, itensPorPagina: 10 },
  nf3e: { pagina: 1, itensPorPagina: 10 },
} as const;
